import { WHISPERBI_SECURITY_API } from '../env';

// Contraparte de whisperbi-back-security's MarketplaceFulfillmentFunction
// (POST /marketplace/claim, Authorizer: NONE -- el comprador todavía no
// tiene cuenta ni JWT en este punto). Sin GET de validación previa: el
// backend valida registration_id/expiración/uso al recibir el claim mismo.
const CLAIM_URL = `${WHISPERBI_SECURITY_API}/marketplace/claim`;

const MarketplaceClaimService = {
  async claim({
    registrationId,
    email,
    password,
    companyName,
    employeesCount,
    acceptedTerms,
    acceptedTermsVersion
  }) {
    if (!registrationId) {
      throw new Error('Falta el identificador de registro de AWS Marketplace.');
    }

    const payload = {
      registration_id: registrationId,
      email,
      password,
      company_name: companyName,
      employees_count: employeesCount,
      accepted_terms: acceptedTerms === true
    };
    if (acceptedTermsVersion) {
      payload.accepted_terms_version = acceptedTermsVersion;
    }

    let response;
    try {
      response = await fetch(CLAIM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(payload)
      });
    } catch (networkError) {
      throw new Error(`No se pudo completar el registro. ${networkError.message}`);
    }

    let data = null;
    try {
      data = await response.json();
    } catch {
      // sin body JSON -- se maneja abajo con el statusCode solo
    }

    if (!response.ok) {
      throw new Error(data?.message || `HTTP ${response.status}`);
    }

    return data;
  }
};

export default MarketplaceClaimService;
